import Layout from '~/client/Layout'
import { useCurrentUser } from '~/client/hooks/auth'
import LoggedIn from './LoggedIn'
import LoggedOut from './LoggedOut'

export default function Page(){
  const { currentUser } = useCurrentUser()
  return currentUser ? <LoggedIn/> : <LoggedOut/>
}
